import axios from 'axios';

export default class ConfiguracaoRepasseService {
    constructor(http, store) {
        this._http = http;
        this._store = store;
    }

    async buscarConfiguracoes() {
        try {
            const response = await axios.get(
                process.env.VUE_APP_RECUPERI_API +
                    'relatorio/configurar-repasse',
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    },
                    params: {
                        cd_apresentante: this._store.getters.cdApresentante
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar configurações de repasse:', error);
            throw error;
        }
    }

    async salvarConfiguracoes(configuracoes) {
        try {
            const payload = {
                cd_apresentante: this._store.getters.cdApresentante,
                envio_automatico_ativo: configuracoes.envioAutomaticoAtivo,
                emails: configuracoes.emails,
                frequencia_envio: configuracoes.frequenciaEnvio
            };

            const response = await axios.post(
                process.env.VUE_APP_RECUPERI_API +
                    'relatorio/configurar-repasse',
                payload,
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao salvar configurações de repasse:', error);
            throw error;
        }
    }
}
